export const REGISTRATION_PRIMARY = "#aece38";
export const REGISTRATION_PRIMARY_DARK = "#8aab15";
export const REGISTRATION_AMBER = "#f0af42";
export const REGISTRATION_FOREST = "#5a6b80";
export const REGISTRATION_FONT_BODY = "'Poppins', sans-serif";
export const REGISTRATION_FONT_DISPLAY = "'Playfair Display', serif";
